import React from 'react';
import SelectionStatus from 'portfolio/components/SelectionStatus';

import WidgetToolbar from 'widgets/WidgetToolbar/WidgetToolbar';
import { useWidgetPortfolioSelectionStatus } from 'widgets/hooks';
import WidgetToolbarShowHidePanel from 'widgets/WidgetToolbarShowHidePanel/WidgetToolbarShowHidePanel';
import { useWidgetMessagesAdornedWithSymbologyWarning } from 'widgets/WidgetSymbologyWarning';
import { StreamMessage } from 'utils/messages/StreamMessage';
import {
    GridApi,
    GridExportButton,
} from '@instinet-analytics/semantic-ui-components';
import OrderVolumeProfileSettings from 'widgets/orderVolumeProfile/components/settings/OrderVolumeProfileSettings';
import { OrderVolumeProfileTimeLabel } from 'widgets/orderVolumeProfile/components/header/OrderVolumeProfileTimeLabel.tsx';
import OrderVolumeProfileColumnPicker from 'widgets/orderVolumeProfile/components/header/OrderVolumeProfileColumnPicker.tsx';
import { OrderVolumeProfileData } from 'widgets/orderVolumeProfile/data/orderVolumeProfileData.ts';
import OrderVolumeProfileHelp from 'widgets/orderVolumeProfile/components/help/OrderVolumeProfileHelp.tsx';

interface OrderVolumeProfileHeaderProps {
    data: OrderVolumeProfileData;
    gridApi?: GridApi;
    messages: StreamMessage[];
}

export default function OrderVolumeProfileHeader(
    props: OrderVolumeProfileHeaderProps
) {
    const { data, messages: messagesProps, gridApi } = props;

    const { hasValidSelection, portfolioSelectionRequirements } =
        useWidgetPortfolioSelectionStatus();

    const widgetMessages = useWidgetMessagesAdornedWithSymbologyWarning();
    const messages = [...messagesProps, ...widgetMessages];

    return (
        <WidgetToolbarShowHidePanel mustShow={!hasValidSelection}>
            <div className="OrderVolumeProfileHeader panel-header">
                {!hasValidSelection && (
                    <div className="toolbar">
                        <SelectionStatus
                            selectionRequirements={
                                portfolioSelectionRequirements
                            }
                            widgetName="Volume Curve Widget"
                        />
                    </div>
                )}
                {hasValidSelection && (
                    <>
                        <div style={{ display: 'flex' }}>
                            <OrderVolumeProfileTimeLabel data={data} />

                            <OrderVolumeProfileHelp />
                        </div>

                        <WidgetToolbar
                            showEditLayout={hasValidSelection}
                            messages={messages}
                            hideMessages={!hasValidSelection}
                            settingsBody={<OrderVolumeProfileSettings />}
                            settingsHeader={'Order Volume Profile Settings'}
                            settingsClassName={'OrderVolumeProfileSettings'}
                            settingsTriggerText={
                                'Order Volume Profile Settings'
                            }
                            fixedItems={
                                <>
                                    {gridApi ? (
                                        <GridExportButton
                                            csvFileName={'OrderVolumeProfile'}
                                            gridApi={gridApi}
                                        />
                                    ) : undefined}

                                    <OrderVolumeProfileColumnPicker />
                                </>
                            }
                        />
                    </>
                )}
            </div>
        </WidgetToolbarShowHidePanel>
    );
}
